module.exports = __webpack_public_path__ + "img/wz5.4356ceef.png";